var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    className: "___12fm75w f1w7gpdv fez10in fg4l7m0",
    "aria-hidden": "true",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.75v-3.77l4.06 2.66a5.38 5.38 0 0 0 5.88 0L19 13.98v3.77c0 .16-.05.32-.15.45l-.01.02-.02.01v.02a3.4 3.4 0 0 1-.41.43c-.28.27-.7.61-1.25.96A9.7 9.7 0 0 1 12 21a9.7 9.7 0 0 1-5.16-1.36 7.43 7.43 0 0 1-1.68-1.42v-.01a.76.76 0 0 1-.16-.46Zm17.16-7.62-8.04 5.25a3.87 3.87 0 0 1-4.24 0L3 10.88v5.37a.75.75 0 0 1-1.5 0V10c0-.09.02-.17.04-.25a.75.75 0 0 1 .3-.88L9.92 3.7a3.87 3.87 0 0 1 4.18 0l8.06 5.17a.75.75 0 0 1 .01 1.26Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatGraduation);
export default __webpack_public_path__ + "static/media/HatGraduation.b1d6da5c31dd5dd2ef8bf7fc2fea64c3.svg";
export { ForwardRef as ReactComponent };